export const templateOfImageThreeColumns = `
  <div class="row content-block">
    <div class="col-12 col-sm-4 column px-8 py-4">
      <img class="custom-image large" src="/assets/editor_images/sample_image_6.jpg" />
    </div>
    <column-separator></column-separator>
    <div class="col-12 col-sm-4 column px-8 py-4">
      <img class="custom-image large" src="/assets/editor_images/sample_image_4.jpg" />
    </div>
    <column-separator></column-separator>
    <div class="col-12 col-sm-4 column px-8 py-4">
      <img class="custom-image large" src="/assets/editor_images/sample_image_7.jpg" />
    </div>
  </div>
`